interface TimelineBackgroundProps {
  weekDates: Date[];
  columnWidth: number;
  height: number;
}

const TimelineBackground: React.FC<TimelineBackgroundProps> = ({
  weekDates,
  columnWidth,
  height,
}) => {
  return (
    <div
      className={`absolute top-0 left-0 w-full flex min-h-[320px]`}
      style={{ height: `${height}px` }}
    >
      {weekDates.map((_, i) => (
        <div
          key={i}
          className={`${
            i % 2 === 0 ? "bg-gray-50" : "bg-gray-100"
          } border-r border-white`}
          style={{ width: `${columnWidth}px` }}
        />
      ))}
    </div>
  );
};

export default TimelineBackground;
